<div
  fxLayout="row"
  [ngClass]="{
    footer: true
  }"
>
  <div
    fxFlex="0 0 auto"
    class="status"
    [ngClass]="{
      none: connectionStatus === 0,
      online: connectionStatus === 1,
      offline: connectionStatus === 2 || connectionStatus === 4,
      reload: connectionStatus === 5,
      error: connectionStatus === 3
    }"
  >
    <span class="status-circle"></span>
    <span class="statuc-text">
      <ng-container *ngIf="connectionStatus !== 5">
        {{ connectionStatusText }}
      </ng-container>
      <ng-container *ngIf="connectionStatus === 5">
        <a (click)="promptReconnect()">{{ connectionStatusText }}</a>
      </ng-container>
    </span>
  </div>
  <div fxFlex="0 0 auto" class="time ticking">{{ now | date: "dd MMM y - HH:mm:ss (Z)" }}</div>
  <div
    fxFlex="0 0 auto"
    class="message"
    *ngIf="notifyMessage != null && notifyMessage.length > 0"
    [innerHTML]="notifyMessage"
  ></div>
  <!-- spacer -->
  <div fxFlex="1 1"></div>

  <div
    fxFlex="0 0 auto"
    class="message vwap"
    *ngIf="vwapMessage != null && vwapMessage.length > 0"
    [innerHTML]="vwapMessage"
  ></div>
  <!-- spacer -->
  <div fxFlex="1 1"></div>

  <div fxFlex="0 0 auto" class="panic" *ngIf="autoHedgingDisabled === true">
    BM Auto Hedging Disabled
  </div>
  <div fxFlex="0 0 auto" class="panic" *ngIf="togglePanicStatus === 0">
    {{ panicStatusText }}
  </div>
  <div fxFlex="0 0 auto" class="rates ticking" [hidden]="!ratesPaused">
    Rates paused ({{ rateResumeCounter }} secs)
  </div>
  <div fxFlex="0 0 auto" class="user-type">{{ userType }}</div>
  <div fxFlex="0 0 auto" *ngIf="systemName" class="system-name">{{ systemName }}</div>
  <div fxFlex="0 0 auto" class="version">v {{ appVersion }}</div>
</div>
